import { DialogContent, DialogContentText, Typography } from '@mui/material';
import ModalCustom from 'components/Modal/Modal';
import useBaseLineOrderWorkunitApi from 'features/ChangeBaseline/ChangeBaselinePages/services/useBaseLineOrderWorkunitApi';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { closeDialogAction } from 'store/actions/dialogsActions';
import { setSnackbarAction } from 'store/actions/snackbarActions';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';

const BaselineOrderConfirmation = () => {
  const history = useHistory();
  const { state, dispatch } = useAppState();
  const appState = useSelector((state) => state.app);
  const { dialogs } = state;
  const isOpen = dialogs.changeBaselineConfirmDialog;
  const { baseLineOrder, sourceOrder } = useSelector((state) => state.changeBaseline);
  const [t] = useTranslation();
  const { submitBaseLineOrder } = useBaseLineOrderWorkunitApi();

  const confirmFn = async () => {
    if (sourceOrder?.baseline_version === 0 || sourceOrder?.baseline_version === null) {
      const res = await submitBaseLineOrder(Number(sourceOrder?.id), Number(baseLineOrder?.id), Number(0), Number(8));
      if (res) {
        dispatch(
          setSnackbarAction({
            message: 'Your initial Order added in baseline table successfully',
            open: true,
            severity: 'success',
          })
        );
      }
    }
    const data = await submitBaseLineOrder(
      Number(sourceOrder?.id),
      Number(baseLineOrder?.id),
      Number(sourceOrder?.baseline_version) + 1,
      Number(6)
    );
    if (data) {
      dispatch(
        setSnackbarAction({
          message: 'Your modifications will overwrite the pervious version of the order successfully',
          open: true,
          severity: 'success',
        })
      );
    } else {
      dispatch(
        setSnackbarAction({ message: 'The order baseline version has not been updated', open: true, severity: 'error' })
      );
    }
    dispatch(closeDialogAction('changeBaselineConfirmDialog'));
    history.push(`/${appState.customer?.slug}/orders/production?status=production`);
  };
  const dialogBody = (
    <DialogContent>
      <DialogContentText>
        <Typography component="span">
          {t('Your modifications will overwrite the pervious version of the order')}
        </Typography>
      </DialogContentText>
    </DialogContent>
  );
  return (
    <ModalCustom
      open={isOpen}
      modalName="changeBaselineConfirmDialog"
      onClose={() => dispatch(closeDialogAction('changeBaselineConfirmDialog'))}
      onConfirm={() => confirmFn()}
      titleText="Confirmation"
      confirmText=" Yes "
      cancelText="Cancel"
      body={dialogBody}
      size="md"
      confirmLoad
    />
  );
};

export default BaselineOrderConfirmation;
